module.exports = __webpack_public_path__ + "static/media/landingone.544ccad8.png";